// [
//   "dashboard",
//   "dashboard/drag_drop",
//   "profile",
//   "marketing/opportunity",
//   "marketing/Getindustrydetails",
//   "marketing/Formshow/",

//   "marketing/cold-calling",
//   "marketing/view-coldcalling",

//   "marketing/all-bookings",

//   "marketing/tender",
//   "marketing/add-tender/",
//   "marketing/edit-tender/",

//   "marketing/bidding",
//   "marketing/add-bidding/",
//   "marketing/edit-bidding/",
//   "setting/bidding",
//   "case-study",
//   "add-case-study",
//   "edit-case-study/",
//   "view-case-study/",

// ]


import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import Reports from "pages/Reports/Reports/index"
// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// setting Module
import CompanySettingIndex from "pages/Setting/CompanySettings"
import GeneralSettingIndex from "pages/Setting/GeneralSettings"
import BiddingIndex from "pages/Setting/Binding"

// Sales Module > Lead
import Lead from "pages/Sales/Lead"
import AddLead from "pages/Sales/Lead/AddLead"
import EditLead from "pages/Sales/Lead/EditLead/EditLead"

// Sales Module > Introducer
import Introducer from "pages/Sales/Introducer"
import AddIntroducer from "pages/Sales/Introducer/AddIntroducer"
import EditIntroducer from "pages/Sales/Introducer/EditIntroducer/EditIntroducer"

// Sales Module > Proposal
import Proposal from "pages/Sales/Proposal"
import AddProposal from "pages/Sales/Proposal/AddProposal"
import EditProposal from "pages/Sales/Proposal/EditProposal/EditProposal"

// Sales Module > Contract
import Contract from "pages/Sales/Contract"
import AddContract from "pages/Sales/Contract/AddContract"
import EditContract from "pages/Sales/Contract/EditContract"
import ViewContract from "pages/Sales/Contract/ViewContract"

// Sales Module > Customers
import Customers from "pages/Sales/Customer"
import AddCustomer from "pages/Sales/Customer/AddCustomer"
import EditCustomer from "pages/Sales/Customer/EditCustomer/EditCustomer"
import AddContact from "pages/Sales/Customer/EditCustomer/AddContact"

// Work 
import DevResourceIndex from "pages/WorkModule/Resource/Develop Resource/DevResourceIndex"
import ResourceIndex from "pages/WorkModule/Resource/ResourceIndex"
import MaintenanceResourceIndex from "pages/WorkModule/Resource/MaintenanceResourceIndex"

import DigitalPlanIndex from "pages/WorkModule/Project Plan/DigitalPlanIndex"
import EditProjectIndex from "pages/WorkModule/Digital Marketing/EditProject/EditProjectIndex"
import MainDmProjectPlan from "pages/WorkModule/Project Plan/MainDmProjectPlan"

import GeneralTask from "pages/WorkModule/GeneralTask/GeneralTask"
import HostingIndexMain from "pages/WorkModule/Hosting/HostingIndexMain"

// setting
import AddTemplate from "pages/Setting/Introducer/AddTemplate"
import EditTemplate from "pages/Setting/Introducer/EditTemplate"
import ContractIndex from "pages/Setting/Contract"
import ContractAddTemplate from "pages/Setting/Contract/ContractAddTemplate"
import ContractEditTemplate from "pages/Setting/Contract/ContractEditTemplate"
import ProposalIndex from "pages/Setting/Proposal"
import IndustryIndex from "pages/Setting/Industry"
import LeadIndex from "pages/Setting/Lead"
import IntroducerIndex from "pages/Setting/Introducer"
import ColdCallingIndex from "pages/Marketing/Cold Calling/ColdCallingIndex"
import AddColdCalling from "pages/Marketing/Cold Calling/AddColdCalling"
import EditColdCalling from "pages/Marketing/Cold Calling/EditColdcalling/EditColdCalling"
import EditBidding from "pages/Marketing/Bidding/EditBidding/EditBidding"
import DataBankIndex from "pages/Marketing/Opportunity/Data Bank/DataBankIndex"
import ViewDataBank from "pages/Marketing/Opportunity/Data Bank/ViewDataBank"
import AccessDenied from "./AccessDenied"
import EditContact from "pages/Sales/Customer/EditCustomer/EditContact"
import GeneratedContract from "pages/Sales/Customer/EditCustomer/GeneratedContract"
import GenerateLinkContract from "pages/Sales/Contract/GenerateContract"
import configure from "configure"
import EditForm from "pages/Marketing/Opportunity/Data Bank/EditForm/EditForm"
import ViewColdCalling from "pages/Marketing/Cold Calling/ViewColdCalling"
import Booking from "pages/Marketing/Booking/Booking"
import CalenderIndex2 from "pages/Calender/CalenderIndex2"
import ImportLogs from "pages/Marketing/Opportunity/ImportLogs"
import Crendential from "pages/Credentials/Crendential"
import EditCredential from "pages/Setting/GeneralSettings/EditCredentials/EditIndex"
import Profile from "pages/Profile/Profile"

import ViewDocument from "pages/Profile/ViewDocument"

import RolesPermission from "pages/AuditLog/RolesPermission"
import KnowledgeBase from "pages/KnowledgeBase/KnowledgeBase"
import AddCredential from "pages/Setting/GeneralSettings/AddCredentials/AddIndex"
import EditTopic from "pages/KnowledgeBase/EditTopic/EditTopic"
import AddTopic from "pages/KnowledgeBase/AddTopic/AddTopic"
import ViewTopic from "pages/KnowledgeBase/ViewTopic/ViewTopic"
import EditDocument from "pages/Profile/EditDocument"
import KnowledgeIndex from "pages/Setting/Knowledge Base"


// Work -> General Settings 
import ViewApproveDoc from "pages/Dashboard/ViewApproveDoc"
import DragDashboard from "pages/Dashboard/DragDashboard"
import NotificationPage from "pages/Setting/NotificationPage"
import Portfolio from "pages/Portfolios/Portfolio/Portfolio"
import Addportfolio from "pages/Portfolios/Portfolio/AddPortfolio"
import EditPortfolio from "pages/Portfolios/Portfolio/EditPortfolio"
import ViewPortfolio from "pages/Portfolios/Portfolio/ViewPortfolio"
import CaseStudy from "pages/Portfolios/CaseStudy/CaseStudy"
import AddCaseStudy from "pages/Portfolios/CaseStudy/AddCaseStudy"
import EditCasestudy from "pages/Portfolios/CaseStudy/EditCaseStudy"
import ViewCaseStudy from "pages/Portfolios/CaseStudy/ViewCaseStudy"
import TenderIndex from "pages/Marketing/Tender/TenderIndex"
import AddTender from "pages/Marketing/Tender/AddTender"
import EditTender from "pages/Marketing/Tender/Edit Tender/EditTender"
import BiddingIndexMain from "pages/Marketing/Bidding/BiddingIndexMain"
import AddBidding from "pages/Marketing/Bidding/AddBidding"
import Hirechynew from "pages/Separate/Hirechy/HirechyNew"
import ConvertCustomer from "pages/Sales/ConvertCustomer/ConvertCustomer"
import LetterAddTemplate from "pages/Setting/CompanySettings/StaffLetters/letterAddTemplate"
import LettersEditTemplate from "pages/Setting/CompanySettings/StaffLetters/LettersEditTemplate"
import CalenderIndex3 from "pages/Calender/CalenderIndex3"
import SeoReportIndex from "pages/Reports/SeoReport"
import TimeSheetReport from "pages/Reports/TimeSheetReport"
import OpportunityLeads from "pages/Sales/Lead/OpportunityLeads"
import RequestForProposal from "pages/Sales/Proposal/Request-For-Proposal"
import RfpPermissions from "pages/Setting/Rfp/rfppermissions"
import ProposalAddTemplate from "pages/Setting/Proposal/ProposalAddTemplate"
import ProposalEditTemplate from "pages/Setting/Proposal/ProposalEditTemplate"
import GenerateLinkProposal from "pages/Sales/Proposal/GenerateLinkProposal"

const authProtectedRoutes = [
  {
    path: `${configure.appUrl}dashboard`,
    component: <DragDashboard />,
    // component: <Dashboard />,
  },
  {
    path: `${configure.appUrl}dashboard/drag_drop`,
    component: <Dashboard />,
    // component: <DragDashboard />,
  },
  {
    path: `${configure.appUrl}profile`,
    component: <Profile />,
  },
  {
    path: `${configure.appUrl}calendar`,
    component: <CalenderIndex2 />,
    module_id: "85",
    type: "view",
  },
  {
    path: `${configure.appUrl}calender/:id`,
    component: <CalenderIndex2 />,
    module_id: "85",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/opportunity/logs`,
    component: <ImportLogs />,
  },
  {
    path: `${configure.appUrl}viewapprovedoc/:id`,
    component: <ViewApproveDoc />,
    module_id: "66",
    type: "edit",
  },


  // Sales Module
  {
    path: `${configure.appUrl}setting/lead`,
    component: <LeadIndex />,
    moduleid: "3",
  },
  {
    path: `${configure.appUrl}setting/introducer`,
    component: <IntroducerIndex />,
  },
  {
    path: `${configure.appUrl}setting/add-template`,
    component: <AddTemplate />,
  },
  {
    path: `${configure.appUrl}setting/edit-template`,
    component: <EditTemplate />,
  },
  {
    path: `${configure.appUrl}setting/contract`,
    component: <ContractIndex />,
    module_id: "76",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/add-contract-template`,
    component: <ContractAddTemplate />,
    module_id: "76",
    type: "add",
  },
  {
    path: `${configure.appUrl}setting/edit-contract-template/:id`,
    component: <ContractEditTemplate />,
    module_id: "76",
    type: "edit",
  },
  { path: `${configure.appUrl}setting/proposal`, component: <ProposalIndex /> },

  // setting module
  {
    path: `${configure.appUrl}setting/companysetting`,
    component: <CompanySettingIndex />,
    moduleid: "70",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/generalsetting`,
    component: <GeneralSettingIndex />,
    module_id: "73",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/generalsetting/:id`,
    component: <EditCredential />,
  },
  {
    path: `${configure.appUrl}setting/generalsetting/addtab`,
    component: <AddCredential />,
  },
  { path: `${configure.appUrl}setting/bidding`, component: <BiddingIndex /> },
  {
    path: `${configure.appUrl}setting/add-letter-template`,
    component: <LetterAddTemplate />,
    // moduleid: "76",
    type: "add",
  },
  {
    path: `${configure.appUrl}setting/edit-letters-template/:id`,
    component: <LettersEditTemplate />,
    // moduleid: "76",
    type: "edit",
  },

  // {
  //   path: `${configure.appUrl}setting/invoice-details`,
  //   component: <InvoiceDetailIndex />,
  //   // module_id: "45",
  //   type: "view",
  // },

  // Sales Module > Lead
  {
    path: `${configure.appUrl}sales/lead`,
    component: <Lead />,
    module_id: "17",
    type: "view",
  },
  {
    path: `${configure.appUrl}sales/add-lead`,
    component: <AddLead />,
    module_id: "17",
    type: "add",
  },
  {
    path: `${configure.appUrl}sales/edit-lead/:id`,
    component: <EditLead />,
    module_id: "17",
    type: "edit",
  },
  {
    path: `${configure.appUrl}sales/opportunity-leads`,
    component: <OpportunityLeads />,
    module_id: "17",
    type: "view",
  },
  {
    path: `${configure.appUrl}sales/junk-leads`,
    component: <OpportunityLeads junk={true} />,
    module_id: "17",
    type: "view",
  },
  // Sales Module > Introducer
  {
    path: `${configure.appUrl}sales/introducer`,
    component: <Introducer />,
    module_id: "18",
    type: "view",
  },
  {
    path: `${configure.appUrl}sales/add-introducer`,
    component: <AddIntroducer />,
    module_id: "18",
    type: "add",
  },
  {
    path: `${configure.appUrl}sales/edit-introducer/:id`,
    component: <EditIntroducer />,
    module_id: "18",
    type: "edit",
  },
  // Sales Module > Proposal
  {
    path: `${configure.appUrl}sales/proposal`,
    component: <Proposal />,
    module_id: "19",
    type: "view",
  },
  {
    path: `${configure.appUrl}sales/add-proposal`,
    component: <AddProposal />,
    module_id: "19",
    type: "add",
  },
  {
    path: `${configure.appUrl}sales/edit-proposal/:id`,
    component: <EditProposal />,
    module_id: "19",
    type: "edit",
  },
  {
    path: `${configure.appUrl}request-for-proposal/:id`,
    component: <RequestForProposal />,
  },
  { path: `${configure.appUrl}setting/proposal`, component: <ProposalIndex /> },
  {
    path: `${configure.appUrl}setting/add-proposal-template`,
    component: <ProposalAddTemplate />,
    module_id: "77",
    type: "add",
  },
  {
    path: `${configure.appUrl}setting/edit-proposal-template/:id`,
    component: <ProposalEditTemplate />,
    module_id: "77",
    type: "edit",
  },

  {
    path: `${configure.appUrl}setting/rfp`,
    component: <RfpPermissions />,
  },

  // Sales Module > Contract
  {
    path: `${configure.appUrl}sales/contract`,
    component: <Contract />,
    module_id: "20",
    type: "view",
  },
  {
    path: `${configure.appUrl}sales/add-contract`,
    component: <AddContract />,
    module_id: "20",
    type: "add",
  },
  {
    path: `${configure.appUrl}sales/edit-contract/:id`,
    component: <EditContract />,
    module_id: "20",
    type: "edit",
  },
  {
    path: `${configure.appUrl}sales/view-contract/:id`,
    component: <ViewContract />,
    module_id: "20",
    type: "view",
  },

  // Sales Module > Customer
  {
    path: `${configure.appUrl}sales/customer`,
    component: <Customers />,
    module_id: "21",
    type: "view",
  },
  {
    path: `${configure.appUrl}sales/add-customer`,
    component: <AddCustomer />,
    module_id: "21",
    type: "add",
  },
  {
    path: `${configure.appUrl}sales/edit-customer/:id`,
    component: <EditCustomer />,
    module_id: "21",
    type: "edit",
  },

  // 
  {
    path: `${configure.appUrl}sales/add-contact/:id`,
    component: <AddContact />,
    module_id: "20",
    type: "edit",
  },
  {
    path: `${configure.appUrl}sales/edit-contact/:id`,
    component: <EditContact />,
    module_id: "20",
    type: "edit",
  },

  // Work Module 
  {
    path: `${configure.appUrl}initial-project-plan/development`,
    component: <DevResourceIndex />,
    module_id: "88",
    type: "view",
  },
  {
    path: `${configure.appUrl}maintenece-project-plan/:id`,
    component: <MaintenanceResourceIndex />,
    module_id: "88",
    type: "view",
  },
  {
    path: `${configure.appUrl}initial-project-plan/:id`,
    component: <ResourceIndex />,
    module_id: "88",
    type: "view",
  },


  {
    path: `${configure.appUrl}initial-project-plan/digital-marketing`,
    component: <DigitalPlanIndex />,
    module_id: "100",
    type: "view",
  },
  {
    path: `${configure.appUrl}initial-project-plan/:id/:seo`,
    component: <MainDmProjectPlan />,
    module_id: "100",
    type: "view",
  },
  {
    path: `${configure.appUrl}digital_marketing/edit_project/:id`,
    component: <EditProjectIndex />,
    module_id: "101",
    type: "edit",
  },

  {
    path: `${configure.appUrl}work/activities`,
    component: <GeneralTask />,
    module_id: "26",
    type: "view",
  },

  {
    path: `${configure.appUrl}work/hosting`,
    component: <HostingIndexMain />,
    module_id: "29",
    type: "view",
  },


  // setting module 
  {
    path: `${configure.appUrl}setting/knowledge-base`,
    component: <KnowledgeIndex />,
    module_id: "81",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/industry`,
    component: <IndustryIndex />,
    module_id: "83",
    type: "view",
  },
  // Marketing Module
  {
    path: `${configure.appUrl}marketing/opportunity`,
    component: <DataBankIndex />,
    module_id: "22",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/Getindustrydetails/:industry_id`,
    component: <ViewDataBank />,
  },
  {
    path: `${configure.appUrl}marketing/Formshow/:company_id`,
    component: <EditForm />,
  },

  {
    path: `${configure.appUrl}marketing/cold-calling`,
    component: <ColdCallingIndex />,
    module_id: "24",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/all-bookings`,
    component: <Booking />,
    module_id: "87",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/add-coldcalling`,
    component: <AddColdCalling />,
    module_id: "24",
    type: "add",
  },
  {
    path: `${configure.appUrl}marketing/edit-coldcalling/:company_id`,
    component: <EditColdCalling />,
    module_id: "24",
    type: "edit",
  },
  {
    path: `${configure.appUrl}marketing/view-coldcalling`,
    component: <ViewColdCalling />,
    module_id: "24",
    type: "view",
  },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${configure.appUrl}`,
    exact: true,
    component: <Navigate to={`${configure.appUrl}dashboard`} />,
  },
  {
    path: `${configure.appUrl}credentials`,
    component: <Crendential />,
    module_id: "10",
    type: "view",
  },
  {
    path: `${configure.appUrl}viewdocument/:id`,
    component: <ViewDocument />,
  },
  {
    path: `${configure.appUrl}editdocument/:id`,
    component: <EditDocument />,
  },
  {
    path: `${configure.appUrl}audit/roles`,
    component: <RolesPermission />,
  },

  // Audit Logs route
  {
    path: `${configure.appUrl}audit-log/rolespermission`,
    component: <RolesPermission />,
  },

  // Knowledge Base Module
  {
    path: `${configure.appUrl}knowledgebase`,
    component: <KnowledgeBase />,
    module_id: "95",
    type: "view",
  },
  {
    path: `${configure.appUrl}edittopic`,
    component: <EditTopic />,
  },
  {
    path: `${configure.appUrl}addtopic`,
    component: <AddTopic />,
  },
  {
    path: `${configure.appUrl}viewtopic`,
    component: <ViewTopic />,
  },


  {
    path: `${configure.appUrl}flaws-gap`, component: <Reports />,
    module_id: "96",
    type: "view",
  },
  {
    path: `${configure.appUrl}notifications`,
    component: <NotificationPage />
  },


  // Gantt Chart 

  {
    path: `${configure.appUrl}timesheet-report`,
    component: <TimeSheetReport />,
    module_id: 32,
    type: "view",
  },

  // Portfolio section

  {
    path: `${configure.appUrl}case-study`,
    component: <CaseStudy />,
    module_id: 113,
    type: "view",
  },
  {
    path: `${configure.appUrl}add-case-study`,
    component: <AddCaseStudy />,
    module_id: 113,
    type: "add",
  },
  {
    path: `${configure.appUrl}edit-case-study/:id`,
    component: <EditCasestudy />,
    module_id: 113,
    type: "edit",
  },
  {
    path: `${configure.appUrl}view-case-study/:id`,
    component: <ViewCaseStudy />,
    module_id: 113,
    type: "view",
  },
  {
    path: `${configure.appUrl}portfolio`,
    component: <Portfolio />,
    module_id: 114,
    type: "view",
  },
  {
    path: `${configure.appUrl}add-portfolio`,
    component: <Addportfolio />,
    module_id: 114,
    type: "add",
  },
  {
    path: `${configure.appUrl}edit-portfolio/:id`,
    component: <EditPortfolio />,
    module_id: 114,
    type: "edit",
  },
  {
    path: `${configure.appUrl}view-portfolio/:id`,
    component: <ViewPortfolio />,
    module_id: 114,
    type: "view",
  },

  {
    path: `${configure.appUrl}marketing/tender`,
    component: <TenderIndex />,
    module_id: "115",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/add-tender/:id`,
    component: <AddTender />,
    module_id: "115",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/edit-tender/:id`,
    component: <EditTender />,
    module_id: "115",
    type: "view",
  },

  {
    path: `${configure.appUrl}marketing/bidding`,
    component: <BiddingIndexMain />,
    module_id: "23",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/add-bidding/:id`,
    component: <AddBidding />,
    module_id: "23",
    type: "view",
  },
  {
    path: `${configure.appUrl}marketing/edit-bidding/:id`,
    component: <EditBidding />,
    module_id: "23",
    type: "view",
  },

  // Hirecy

  {
    path: `${configure.appUrl}company-structure`,
    component: <Hirechynew />,
    module_id: "116",
    type: "view",
  },
  {
    path: `${configure.appUrl}customer-onboarding/:id`,
    component: <ConvertCustomer />,
    // module_id: "45",
    // type: "view",
  },

  {
    path: `${configure.appUrl}seo-report`,
    component: <SeoReportIndex />,
    // module_id: "118",
    type: "view",
  },
  // {
  //   path: `${configure.appUrl}setting/hsn`,
  //   component: <HsnIndex />,
  // },
]


const publicRoutes = [
  { path: `${configure.appUrl}logout`, component: <Logout /> },
  { path: `${configure.appUrl}login`, component: <Login /> },
  { path: `${configure.appUrl}forgot-password`, component: <ForgetPwd /> },
  { path: `${configure.appUrl}register`, component: <Register /> },
  { path: `${configure.appUrl}access-denied`, component: <AccessDenied /> },
  {
    path: `${configure.appUrl}introducer/:id`,
    component: <GeneratedContract />,
  },
  {
    path: `${configure.appUrl}sales/contract/:id`,
    component: <GenerateLinkContract />,
  },
  {
    path: `${configure.appUrl}sales/proposal/:id`,
    component: <GenerateLinkProposal />,
  },
  {
    path: `${configure.appUrl}calendar/:id`,
    component: <CalenderIndex3 />,
  },
  // {
  //   path: `${configure.appUrl}staff/Letters/:id`,
  //   component: <GenerateLinkLetters />
  // },
]

export { authProtectedRoutes, publicRoutes }
